import React, {useEffect, useState} from 'react';
import '../../App.css';
import RentHomeItem from '../RentHomeItem';
// import { useLocation } from "react-router-dom";
import axios from 'axios';

const RentHome=()=> {
    
    const myParam = window.location.search;
    var productId= new URLSearchParams(myParam).get("id");
    const [loading, setLoading] = useState(false);
    const [posts, setPosts] = useState({});
    console.log(productId)
    useEffect(() => {
        const loadPost = async () => {
  
            // Till the data is fetch using API 
            // the Loading page will show.
            setLoading(true);
  
            // Await make wait until that 
            // promise settles and return its result
            const response = await axios.get(
            "https://api.bubble.africa/houses/one/"+productId).then((res)=>{
                setPosts(res.data);
                console.log(response)
            }).catch(()=>{
                console.log("try")
            });
             try{
                posts.rooms = JSON.parse(JSON.parse(posts.rooms))
             } catch {
                posts.rooms = []
             }
            // After fetching data stored it in posts state.
            
  
            // Closed the loading page
            setLoading(false);
        }
  
        // Call the function
        loadPost();
    },[]);
    return (
        <>
        {loading ? (
                <>
                <img alt='Loader' width ='100%' src='./images/loader.png' />
                </>) :
            (   
                //console.log(posts)+   // Presently we only fetch 
                // title from the API 
                <RentHomeItem 
                    key = {posts.id}
                    id={posts.id} 
                    src={posts.attachments} 
                    name={posts.name} 
                    bed={posts.beds} 
                    bath={posts.baths} 
                    amount={posts.amount}
                    electricity = {posts.electricity}
                    likes={posts.liked_by ? (posts.liked_by.split(",").length - 1) :0}
                    furnished={posts.furnished} 
                    description={posts.description} 
                    location={posts.location} 
                    legal={posts.legal_fee ? Number(posts.legal_fee): 0} 
                    security={posts.security_deposit ? Number(posts.security_deposit): 0}
                    service={posts.service_fee ? Number(posts.service_fee): 0} 
                    processing={posts.processing_fee ? Number(posts.processing_fee): 0} 
                    rooms={posts.rooms ? posts.rooms : []}
                />
            )
        }
        </>
        
    )
}

export default RentHome ;